export default {
  label: {
    ok: '是',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
  },
  detailNavTitle: {
    gameBalance: '{{game}} 余额',
    balanceGame: {
      Dice: '骰子',
      Color: '颜色',
      '3Digit': 'ABC',
      Matka: 'Matka',
      MixLottery: 'State',
      ScratchOff: '刮刮',
      BigTurntable: '转盘',
      QuickRace: '竞速',
      Kerala: 'Kerala',
      Sports: '体育',
    },
  },
  tip: {
    success: '成功',
  },
  text: {},
};
